import { render, staticRenderFns } from "./GeneralNotes.vue?vue&type=template&id=20d089b6&"
import script from "./GeneralNotes.vue?vue&type=script&lang=js&"
export * from "./GeneralNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports